import { useAtom } from "jotai";
import { FeeAtom, FeeIncreaseAtom, YearsAtom } from "./atoms";
import { useCallback } from "react";
import { mapRange } from "./mapRange";

export function useGetMemberFee() {
  const [initialFee] = useAtom(FeeAtom);
  const [deltaFee] = useAtom(FeeIncreaseAtom);
  const [years] = useAtom(YearsAtom);
  return useCallback(
    (currentYear: number) => {
        return initialFee * Math.pow(1 + deltaFee, currentYear);
    },
    [deltaFee, years, initialFee]
  );
}
